/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RefreshButton from './ui/RefreshButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Badge } from './ui/badge';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Switch } from './ui/switch';
import {
  Coins, Package, Gift, Clock, Zap, Users, TrendingUp, TrendingDown,
  Plus, Edit, Trash2, Eye, Search, Filter, Download, RefreshCw,
  UserPlus, Cake, Award, ShoppingCart, FileText, Key, AlertTriangle,
  CheckCircle, XCircle, Calendar, Timer, Percent, Hash, ArrowUpRight,
  ArrowDownRight, BarChart3, PieChart, Activity, Settings, Star, CreditCard,
  HelpCircle, BookOpen
} from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import StripeCheckoutButton from './StripeCheckoutButton';
import Sparkline from './credits/Sparkline';
import CreditUsagePlansTab from './CreditUsagePlansTab';
import CreditStatsAdvancedTab from './CreditStatsAdvancedTab';
import CreditAlertsAdminTab from './CreditAlertsAdminTab';


export const GCBonusTab = ({ ctx }) => {
  const {
    actions, activeTab, attributeForm, attributeSearch, bonusForm, bonusRules,
    bulkAttributeForm, creditTypes, duplicateRaison, duplicateSource, duplicateTargetSearch,
    duplicateTargetUserId, editForm, editTarget, editingBonus, editingPack, loading,
    packForm, packs, searchTerm, selectedUserIds, showAttributeModal, showBonusModal,
    showBulkAttributeModal, showDuplicateModal, showEditModal, showPackModal, sparkSeries, stats,
    transactions, userBalances,
    setActions, setActiveTab, setAttributeForm, setAttributeSearch, setBonusForm, setBonusRules,
    setBulkAttributeForm, setCreditTypes, setDuplicateRaison, setDuplicateSource, setDuplicateTargetSearch,
    setDuplicateTargetUserId, setEditForm, setEditTarget, setEditingBonus, setEditingPack,
    setLoading, setPackForm, setPacks, setSearchTerm, setSelectedUserIds, setShowAttributeModal,
    setShowBonusModal, setShowBulkAttributeModal, setShowDuplicateModal, setShowEditModal, setShowPackModal,
    setSparkSeries, setStats, setTransactions, setUserBalances,
    exportUsersCsv, filteredUsers, handleAttributeCredits, handleBulkAttribute, handleBulkDelete,
    handleConfirmDuplicate, handleDeletePack, handleDeleteUserCredits, handleExportFiltered,
    handleExportSelection, handleSaveBonus, handleSaveEdit, handleSavePack, loadData, openDuplicateModal,
    openEditModal, renderIcon, resetPackForm, toggleSelectAllFiltered, toggleUserSelection,
    getAuthHeader, CountdownWidget, StatsCard, COLORS, AVAILABLE_ICONS,
  } = ctx;
  return (
        <TabsContent value="bonus" className="space-y-4">
          <div className="flex justify-end mb-4">
            <Button onClick={() => { setEditingBonus(null); setShowBonusModal(true); }} className="bg-green-600 hover:bg-green-700">
              <Plus className="w-4 h-4 mr-2" />
              Nouvelle règle de bonus
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {bonusRules.map((rule) => (
              <Card key={rule.id} className="border-l-4 border-green-500">
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-green-100 rounded-lg">
                        {renderIcon(rule.icone, "w-5 h-5 text-green-600")}
                      </div>
                      <div>
                        <CardTitle className="text-lg">{rule.nom}</CardTitle>
                        <Badge variant="outline">{rule.code}</Badge>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <Button variant="ghost" size="sm" onClick={() => {
                        setEditingBonus(rule);
                        setBonusForm({
                          code: rule.code,
                          nom: rule.nom,
                          description: rule.description,
                          type_declencheur: rule.type_declencheur,
                          credits_bonus: rule.credits_bonus,
                          bonus_pourcentage: rule.bonus_pourcentage || 0,
                          type_credit: rule.type_credit,
                          duree_validite_jours: rule.duree_validite_jours,
                          conditions: rule.conditions || {},
                          icone: rule.icone
                        });
                        setShowBonusModal(true);
                      }}>
                        <Edit className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 mb-3">{rule.description}</p>
                  <div className="flex flex-wrap gap-2">
                    <Badge className="bg-green-600 text-white font-semibold">
                      <Zap className="w-3 h-3 mr-1" />
                      +{rule.credits_bonus} crédits
                    </Badge>
                    {rule.duree_validite_jours && (
                      <Badge variant="outline">
                        <Clock className="w-3 h-3 mr-1" />
                        Valide {rule.duree_validite_jours} jours
                      </Badge>
                    )}
                    <Badge variant="outline" className="capitalize">
                      {rule.type_declencheur.toLowerCase()}
                    </Badge>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </TabsContent>
  );
};

export default GCBonusTab;
